import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { useVendorManagementApi } from './useVendorManagementApi';
import { getErrorFromResponse } from '../../../../../utility/utils';

export const useVendorUpdates = (RefreshData) => {
   // ______________ Modals State ______________
   const [showVendorModal, setShowVendorModal] = useState(false);
   const [showDeleteModal, setShowDeleteModal] = useState(false);
   const [selectedVendor, setSelectedVendor] = useState(null);

   const { addVendor, deleteVendor, updateVendor, updatingData } = useVendorManagementApi();

   const AddNewVendor = async (vendorBody) => {
      try {
         const response = await addVendor(vendorBody);
         setShowVendorModal(false);
         setSelectedVendor(null);

         Swal.fire({
            title: 'Success',
            text: 'Vendor added successfully.',
            type: 'success',
            timer: 1200,
            showConfirmButton: false,
         });

         await RefreshData();
         return response;
      } catch (error) {
         console.error('Error adding vendor:', error);

         const errorMsg = getErrorFromResponse(error, 'There was an error adding the vendor. Please try again.');

         Swal.fire({
            title: 'Error',
            text: errorMsg,
            type: 'error',
         });
      }
   };

   const DeleteVendor = async (vendorId) => {
      try {
         const response = await deleteVendor(vendorId);
         setShowDeleteModal(false);
         setSelectedVendor(null);

         Swal.fire({
            title: 'Success',
            text: 'Vendor deleted successfully.',
            type: 'success',
            timer: 1200,
            showConfirmButton: false,
         });

         await RefreshData(true);
         return response;
      } catch (error) {
         console.error('Error deleting vendor:', error);
         const errorMsg = getErrorFromResponse(error, 'There was an error deleting the vendor. Please try again.');

         Swal.fire({
            title: 'Error',
            text: errorMsg,
            type: 'error',
         });
      }
   };

   const UpdateVendor = async (vendorId, vendorBody) => {
      try {
         const response = await updateVendor(vendorId, vendorBody);
         setShowVendorModal(false);
         setSelectedVendor(null);

         Swal.fire({
            title: 'Success',
            text: 'Vendor updated successfully.',
            type: 'success',
            timer: 1200,
            showConfirmButton: false,
         });

         await RefreshData();
         return response;
      } catch (error) {
         console.error('Error updating vendor:', error);
         const errorMsg = getErrorFromResponse(error, 'There was an error updating the vendor. Please try again.');

         Swal.fire({
            title: 'Error',
            text: errorMsg,
            type: 'error',
         });
      }
   };

   // ______________________________________________________________________

   return {
      showVendorModal,
      setShowVendorModal,

      showDeleteModal,
      setShowDeleteModal,

      selectedVendor,
      setSelectedVendor,

      AddNewVendor,
      DeleteVendor,
      UpdateVendor,

      updatingData,
   };
};
